import { Control, Controller, FieldValues } from 'react-hook-form'

import { NewsletterCheckbox } from '@/entities/assent'

import { Input, RHFPhoneInput } from '@/shared/ui'
import { Option, Select } from '@/shared/ui'
import { RHFEmailInput } from '@/shared/ui'
import { Heading } from '@/shared/ui/heading'
import { SegmentedControl } from '@/shared/ui/segmented-control'
import { Textarea } from '@/shared/ui/Typography/Textarea'

import cl from './form.module.scss'

type FormProps = {
	userType: 'individual' | 'legal'
	availableServiceCenters: Option[]
	formControl: Control<FieldValues>
	isLoading?: boolean
	userInfoIsLoading?: boolean
	shopsInfoIsLoading?: boolean
	showNewsletterCheckbox?: boolean
	isNewsletterAccepted?: boolean
	onNewsletterChange?: (checked: boolean) => void
}

const userOptions = [
	{ label: 'Физическое лицо', value: 'individual' },
	{ label: 'Юридическое лицо', value: 'legal' }
]

export const Form = (props: FormProps) => {
	const {
		userType,
		formControl,
		availableServiceCenters = [],
		userInfoIsLoading,
		isLoading,
		showNewsletterCheckbox,
		isNewsletterAccepted,
		onNewsletterChange
	} = props

	return (
		<>
			<div className={cl.formHeader}>
				<Heading className={cl.title} preset="h3">
					Оставить заявку
				</Heading>

				<Controller
					control={formControl}
					defaultValue="individual"
					name="USER_TYPE"
					render={({ field: { value, onChange } }) => (
						<SegmentedControl className={cl.tabs} size="md" options={userOptions} value={value} onChange={onChange} />
					)}
				/>
			</div>

			<div className={cl.root}>
				<Controller
					control={formControl}
					name="NAME"
					render={({ field: { value, onChange }, fieldState: { error, invalid } }) => (
						<Input
							label="Имя*"
							name="first-name"
							fullWidth
							value={value}
							helperText={error?.message}
							onChange={onChange}
							onClear={() => onChange('')}
							isError={invalid}
							isLoading={userInfoIsLoading}
							disabled={isLoading}
						/>
					)}
				/>
				<Controller
					control={formControl}
					name="LAST_NAME"
					defaultValue={''}
					render={({ field: { value, onChange }, fieldState: { error, invalid } }) => (
						<Input
							label="Фамилия"
							name="second-name"
							fullWidth
							value={value}
							helperText={error?.message}
							onChange={onChange}
							onClear={() => onChange('')}
							isError={invalid}
							isLoading={userInfoIsLoading}
							disabled={isLoading}
						/>
					)}
				/>

				<RHFEmailInput
					name="EMAIL"
					control={formControl}
					required={false}
					fullWidth
					isLoading={userInfoIsLoading}
					disabled={isLoading}
				/>

				<RHFPhoneInput
					name="PHONE"
					control={formControl}
					label="Телефон*"
					fullWidth
					isLoading={userInfoIsLoading}
					disabled={isLoading}
				/>

				{userType === 'individual' && (
					<Controller
						control={formControl}
						name="STORE_ID"
						render={({ field: { value, onChange }, fieldState: { invalid } }) => (
							<>
								<Select
									className={cl.select}
									options={availableServiceCenters}
									value={value}
									onChange={onChange}
									disabled={isLoading}
									adaptive
									error={invalid}
									placeholder={'Выберите сервисный центр*'}
								/>
							</>
						)}
					/>
				)}

				<Controller
					control={formControl}
					defaultValue=""
					name="COMMENTS"
					render={({ field: { value, onChange } }) => (
						<>
							<Textarea
								className={cl.textarea}
								disabled={isLoading}
								placeholder="Опишите, что случилось и, по возможности, укажите серийный номер устройства"
								value={value}
								onChange={onChange}
							/>
						</>
					)}
				/>

				{showNewsletterCheckbox && (
					<div className={cl.checkboxes}>
						<NewsletterCheckbox checked={isNewsletterAccepted} onChange={onNewsletterChange} />
					</div>
				)}
			</div>
		</>
	)
}
